import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {QuestionType} from '../../constants';
import {Subject} from 'rxjs';
import {GlobalQuestionService} from '../../services/global-question.service';
import {debounceTime} from 'rxjs/operators';

@Component({
    selector: 'app-question-claims-items-list',
    templateUrl: './question-claims-items-list.component.html',
    styleUrls: ['./question-claims-items-list.component.scss'],
    standalone: false
})
export class QuestionClaimsItemsListComponent implements OnInit, OnChanges {

  @Input() question: Question;
  @Input() itemQuestions: Question[] = [];
  @Input() selectedItemId: any;
  @Input() showRemove = true;
  @Input() editCardMarginBottom = false;
  @Input() isEdit = false;
  @Output() questionAnswer = new EventEmitter<any>();


  showIcon = true;
  showPremium = true;
  childrenQuestions: Question[] = [];
  enteredItems: any[] = [];
  questionType = QuestionType;
  isSavingData = false;
  icon = '#cart-discount';
  parameters: any[] = [];
  questionChanged = new Subject<{ question: Question, item_index: number }>();

  constructor(public questionService: GlobalQuestionService) {
  }

  ngOnInit(): void {
    this.questionChanged.pipe(
      debounceTime(300)
    ).subscribe(x => {
      if (x?.question && x?.item_index >= 0) {
        this.saveSingleQuestion(x?.question, x?.item_index);
      }
    });

    if (this.question && !this.isEdit) {
      if (this.question?.parameter) {
        this.parameters = JSON.parse(this.question?.parameter);
      }

      if (this.parameters?.length) {
        const show_icon = this.parameters?.find(x => x?.parameter === 'show_icon');
        const icon = this.parameters?.find(x => x?.parameter === 'icon');
        const show_premium = this.parameters?.find(x => x?.parameter === 'show_premium');

        this.showIcon = +show_icon?.value !== 0;
        this.showPremium = +show_premium?.value !== 0;
        this.icon = icon?.value ? icon?.value : '#cart-discount';
      }

      this.questionService.getChildrenQuestions(this.question?.cent_aq_question_id)
        .subscribe(questions => {
          for (const q of questions) {
            this.childrenQuestions.push(Object.assign({}, q));
          }

          this.childrenQuestions.sort((a, b) => a.page_index > b.page_index ? 1 : a.page_index < b.page_index ? -1 : 0);
          this.enteredItems = [];
          this.questionService.getLists(this.question?.cent_aq_question_id)
            .subscribe(items => {
              if (items?.length) {
                this.enteredItems = [];
                for (const item of items) {
                  const item_child_questions = JSON.parse(item?.child_questions);
                  const child_questions = JSON.parse(JSON.stringify(this.childrenQuestions));
                  if (item_child_questions?.length && child_questions?.length) {
                    for (const q of child_questions) {
                      for (const i of item_child_questions) {
                        if (q?.cent_aq_question_id === i?.question_id) {
                          q.answer = i?.answer;
                        }
                      }
                    }
                  }

                  if (child_questions?.length) {
                    const newQuestions = JSON.parse(JSON.stringify(child_questions));
                    this.enteredItems.push({
                      questions: newQuestions,
                      item_id: +item?.item_id,
                      description_1: '',
                      description_2: '',
                      frequency: item?.frequency,
                      premium: item?.premium
                    });
                    if (this.enteredItems?.length) {
                      this.getDescriptions(this.enteredItems?.length - 1);
                      this.checkQuestionEmit();
                    }
                  }
                }
              } else {
                const newQuestions = JSON.parse(JSON.stringify(this.childrenQuestions));
                this.enteredItems.push({
                  questions: newQuestions,
                  item_id: 1,
                  description_1: '',
                  description_2: '',
                  frequency: '',
                  premium: 0
                });
              }
            });
        });
    } else {

    }
  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  addAnother(): void {
    if (this.enteredItems.every(item => item?.questions.every(q => q.answer))) {
      const newQuestions = JSON.parse(JSON.stringify(this.childrenQuestions));
      for (const q of newQuestions) {
        q.answer = '';
        q.item_id = (+this.enteredItems[this.enteredItems?.length - 1]?.item_id + 1).toString();
      }
      this.enteredItems.push({
        questions: newQuestions,
        item_id: +this.enteredItems[this.enteredItems?.length - 1]?.item_id + 1,
        description_1: '',
        description_2: '',
        frequency: '',
        premium: 0
      });
    }
  }

  joinString(name: string, surname: string): string {
    return name + ' ' + surname;
  }

  onInputChange(value: any, questionIndex: number, enteredItemsIndex: number): void {
    if (value) {
      this.enteredItems[enteredItemsIndex].questions[questionIndex] = value;
      this.enteredItems[enteredItemsIndex].questions[questionIndex].item_id = this.enteredItems[enteredItemsIndex]?.item_id.toString();
      this.questionChanged.next({
        question: this.enteredItems[enteredItemsIndex].questions[questionIndex],
        item_index: enteredItemsIndex
      });
      this.getDescriptions(enteredItemsIndex);
    }
  }

  saveSingleQuestion(question: Question, item_index: number): void {
    this.questionService.saveIndividualAnswer(question, question?.item_id)
      .subscribe(() => {
        if (this.enteredItems[item_index]?.questions?.every(q => q?.answer)) {
          this.question.answer = 'Multiple Answers';
          this.question.item_id = this.enteredItems[item_index]?.item_id.toString();
          this.saveParentQuestion(this.question, item_index);
        }
      });
  }

  saveParentQuestion(question: Question, item_index: number): void {
    if (question) {
      this.questionService.saveIndividualAnswer(question, question?.item_id)
        .subscribe(x => {
          if (x) {
            //this.getPremium(question, item_index);
          }
        });
    }
  }

  getPremium(question: Question, item_index: number): void {
    this.questionService.getPremium(question.product_class_id, question?.item_id, question?.product_id)
      .subscribe(r => {
        if (r?.length) {
          this.enteredItems[item_index].premium = r[0]?.premium;
        }
        this.setShoppingCart(question);
        this.checkQuestionEmit();
      });
  }

  setShoppingCart(question: Question): void {
    this.questionService.setShoppingCart(question, question?.item_id);
  }

  getDescriptions(itemIndex: number): void {
    if (this.parameters?.length) {
      const description_1 = this.parameters.find(x => x?.parameter === 'description_1');
      const description_2 = this.parameters.find(x => x?.parameter === 'description_2');
      if (description_1) {
        const values = description_1?.value?.split('|');
        let description_1_value = '';
        for (const v of values) {
          const question = this.enteredItems[itemIndex].questions.find(q => q.cent_aq_question_id === +v);
          if (question) {
            if (!description_1) {
              description_1_value = question?.answer;
            } else {
              description_1_value += ' ' + question?.answer;
            }
          }
        }
        this.enteredItems[itemIndex].description_1 = description_1_value;
      }
      if (description_2) {
        const values = description_2?.value?.split('|');
        let description_2_value = '';
        for (const v of values) {
          const question = this.enteredItems[itemIndex].questions.find(q => q.cent_aq_question_id === +v);
          if (question) {
            if (!description_2) {
              description_2_value = question?.answer;
            } else {
              description_2_value += ' ' + question?.answer;
            }
          }
        }
        this.enteredItems[itemIndex].description_2 = description_2_value;
      }
    }
  }

  checkQuestionEmit(): void {
    if (this.enteredItems.every(i => i.questions?.every(q => q.answer))) {
      if (!this.question?.answer) {
        const answers = [];
        for (const q of this.enteredItems[this.enteredItems?.length - 1]?.questions) {
          answers.push(q?.answer);
        }
        this.question.answer = answers?.join('|');
      }
      this.questionAnswer.emit(this.question);
    }
  }

  removeItem(index: any): void {
    this.questionService.removeRiskListItem(this.question.product_class_id, this.enteredItems[index]?.item_id.toString())
      .subscribe(r => {
        this.enteredItems.splice(index, 1);
      });
  }
}
